import { capture } from "./capture";

export const DatamatesTracking = {
  /** Template selected in the define step. */
  templateSelected: (templateType: string, templateName: string) => {
    capture("datamates.template_selected", {
      template_type: templateType,
      template_name: templateName,
    });
  },

  /** Wizard step changed. */
  wizardStepChanged: (fromStep: number, toStep: number) => {
    capture("datamates.wizard_step_changed", { from_step: fromStep, to_step: toStep });
  },

  /** Integration toggled on or off. */
  integrationToggled: (integrationId: string, integrationType: string, selected: boolean) => {
    capture("datamates.integration_toggled", {
      integration_id: integrationId,
      integration_type: integrationType,
      selected,
    });
  },

  /** Datamate created successfully. */
  created: (integrationCount: number, memoryEnabled: boolean, privacy: string) => {
    capture("datamates.created", {
      integration_count: integrationCount,
      memory_enabled: memoryEnabled,
      privacy,
    });
  },

  /** Datamate creation failed. */
  createFailed: (error: string) => {
    capture("datamates.create_failed", { error });
  },

  /** Datamate edited successfully. */
  edited: (datamateId: string) => {
    capture("datamates.edited", { datamate_id: datamateId });
  },

  /** Custom integration created. */
  customIntegrationCreated: (integrationType: string) => {
    capture("datamates.custom_integration_created", { integration_type: integrationType });
  },

  /** Custom integration edited. */
  customIntegrationEdited: (integrationId: string) => {
    capture("datamates.custom_integration_edited", { integration_id: integrationId });
  },
};
